import { RESPONSE } from '@factories/vasApiResponseConstants'
import { ASSET_ADDITION_SERVICE } from '@components/MainWidget/ChallanWidget/challanConstants'
import { getVariantId } from '@components/MainWidget/ChallanWidget/challanConfig'
import logger from '@utils/logger'
import {
  ABORT_ERROR,
  ALTERNATIVE_ERROR,
  ASSET_DATA_ERROR,
  MAPPING_ALREADY_EXIST,
  RATE_LIMIT_EXCEEDED_EXCEPTION,
  TIMEOUT,
  VERIFY_ERROR,
} from './assethelperConstants'

export const fetchWithTimeout = async ({ url, options = {}, timeout = 3000 }) => {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), timeout)

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    })
    clearTimeout(timeoutId)
    return response
  } catch (error: any) {
    clearTimeout(timeoutId)
    if (error?.name === ABORT_ERROR) {
      logger.error(RESPONSE.ABORT_ERROR(timeout), url)
    }
    logger.error(TIMEOUT, error)
  }
}

// Process asset data without getChallan callback
export const processAssetData = async (assetData, fetchUrl) => {
  try {
    const variantId = getVariantId(assetData)

    if (variantId) {
      const variantResponse: any = await fetchWithTimeout({
        url: `${fetchUrl}autoImageService/?variant_id=${variantId}`,
      })
      const variantData = await variantResponse.json()
      return {
        ...assetData,
        variantDetails: variantData,
      }
    }
    return assetData
  } catch (error) {
    logger.error(ASSET_DATA_ERROR, error)
    return assetData
  }
}

const handleAlternativeAssetFlow = async ({ userId, regNo, fetchUrl }) => {
  try {
    const apiEndpoint = `${fetchUrl}assetServiceVehicleService?userId=${userId}`

    const vehicleAssetsResponse: any = await fetchWithTimeout({ url: apiEndpoint })

    const vehicleAssetsData = await vehicleAssetsResponse.json()
    const matchedAsset = vehicleAssetsData.vehicle.find(asset => asset.asset_number === regNo)

    if (matchedAsset?.variant_id?.length > 0) {
      return await processAssetData(matchedAsset, fetchUrl)
    }
    return null
  } catch (error) {
    logger.error(ALTERNATIVE_ERROR, error)
    return null
  }
}

export const verifyOtpSuccessCallBack = async ({ regNo, phone, envValue, fetchUrl, phoneTemp = null }) => {
  try {
    const phoneNumber = phone || phoneTemp
    const apiEndpoint = `${fetchUrl}${ASSET_ADDITION_SERVICE(regNo, phoneNumber)}`

    const response: any = await fetchWithTimeout({ url: apiEndpoint })

    const { assetResponseData, userId } = await response.json()
    if (assetResponseData?.error_code === RATE_LIMIT_EXCEEDED_EXCEPTION) {
      const alternativeData = await handleAlternativeAssetFlow({ userId, regNo, fetchUrl })
      return {
        assetData: {
          ...alternativeData,
          isRateLimited: true,
        },
      }
    }

    if (assetResponseData?.error_code === MAPPING_ALREADY_EXIST) {
      const alternativeData = await handleAlternativeAssetFlow({ userId, regNo, fetchUrl })
      return {
        assetData: alternativeData,
      }
    }

    const processedData = await processAssetData(assetResponseData, fetchUrl)
    return {
      assetData: processedData,
    }
  } catch (error) {
    logger.error(VERIFY_ERROR, error)
    return {
      error: true,
    }
  }
}
